import { RefObject, useLayoutEffect, useState } from 'react';

export function useTruncatedText(elementRef: RefObject<HTMLInputElement>, text: string): string {
  const [truncatedText, setTruncatedText] = useState(text);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }

    const style = getComputedStyle(element);

    const totalWidth = element.getBoundingClientRect().width;
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    const availableWidth = totalWidth - paddingLeft - paddingRight;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
      return;
    }
    context.font = `${style.fontSize} ${style.fontFamily}`;

    let candidate = text;
    let measured = context.measureText(candidate).width;
    const minTextLength = 3;
    while (measured > availableWidth && candidate.length > minTextLength) {
      candidate = candidate.slice(0, -1);
      measured = context.measureText(`${candidate}…`).width;
    }

    setTruncatedText(candidate !== text ? `${candidate}…` : candidate);
  }, [elementRef, text]);

  return truncatedText;
}
